import { render } from "./PartnersCustomersHeatmap.vue?vue&type=template&id=44f10824"
import script from "./PartnersCustomersHeatmap.vue?vue&type=script&lang=js"
export * from "./PartnersCustomersHeatmap.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__